export const colunasUpload = [
  {
    title: 'Nome',
    dataIndex: 'nome',
    key: 'nome'
  },
]